import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux'
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from '../../components/Modal.js';
import Tabla from '../../components/Tabla2.js';
import Api from '../../api.js';

const Modulo = () => {
  let infoGeneral = useSelector((state) => state.infoGeneral.value);
  let infoUsuario = useSelector((state) => state.infoUsuario.value);
  let [espe, setEspe] = useState([]);
  const [tuto, setTuto] = useState([]);
  let more = [
    { text: "No. de Chip", value: 1 },
    { text: "Historia Clinica", value: 2 }
  ];

  let api = new Api();

  //Escaner--------------------------------------------------------------------------------- 
  const searchParams = new URLSearchParams(window.location.search);
  // const documentTypeMapping = {
  //   cc: 1,
  //   ti: 2,
  //   ce: 3,
  //   pasaporte: 4,
  //   nip: 5,
  //   nit: 6,
  //   id: 7,
  //   driving_license: 8,
  //   rnc: 9,
  //   rut: 10,
  //   visa: 11,
  //   pe: 12,
  //   pt: 13,
  // };

  // const urlData = {
  //   firstName: searchParams.get("nombres") || "",
  //   lastName: searchParams.get("apellidos") || "",
  //   documentTypeId: documentTypeMapping[searchParams.get("tipo")?.toLowerCase()] || "",
  //   documentNumber: searchParams.get("docu") || "",
  //   birthdate: searchParams.get("nacimiento") || "", 
  //   gender: ["f", "F"].includes(searchParams.get("sexo")) 
  //     ? "F"
  //     : ["m", "M"].includes(searchParams.get("sexo")) 
  //     ? "M"
  //     : "",
  //   phone: searchParams.get("telefono") || "",
  //   email: searchParams.get("correo") || "",
  // };

  //Configurables---------------------------------------------------------------------------
  const titulo = "Pacientes";
  const icono = "fa-paw";
  const modals = [
    {
      titulo: "Nuevo Paciente",
      endpoint: "patient",
      buttonText: "Guardar",
      urlCall: "new",
      method: "POST",
      fields: [
        {
          label: "row", elements: [
            { label: "Tipo de documento", name: "documentTypeId", element: "select", required: true, isNumber: true, options: more },
            { label: "No. de Documento", name: "documentNumber", element: "input", type: "text", required: false, isNumber: false },
          ]
        },
        {
          label: "row", elements: [
            { label: "Tipo de Especie", name: "speciesId", element: "select", required: true, isNumber: true, options: espe },
            { label: "Nombre Paciente", name: "firstName", element: "input", type: "text", required: true, isNumber: false },
          ]
        },
        {
          label: "row", elements: [
            { label: "Tutor", name: "tutorId", element: "select", required: true, isNumber: true, options: tuto },
          ]
        }
      ],
      dataMask: null
    },
    {
      titulo: "Editar Paciente",
      endpoint: "patient",
      buttonText: "Editar",
      urlCall: "edit",
      method: "PUT",
      fields: [
        {
          label: "row", elements: [
            { label: "Tipo de documento", name: "documentTypeId", element: "select", required: true, isNumber: true, options: more },
            { label: "No. de Documento", name: "documentNumber", element: "input", type: "text", required: false, isNumber: false },
          ]
        },
        {
          label: "row", elements: [
            { label: "Tipo de Especie", name: "speciesId", element: "select", required: true, isNumber: true, options: espe },
            { label: "Nombre Paciente", name: "firstName", element: "input", type: "text", required: true, isNumber: false },
          ]
        },
        {
          label: "row", elements: [
            { label: "Tutor", name: "tutorId", element: "select", required: true, isNumber: true, options: tuto },
          ]
        }
      ],
      dataMask: null
    }
  ];
  let tabla1;
  if (infoUsuario.role.name == "ADMIN" || infoUsuario.role.name == "EMPLOYEE") {
    tabla1 = {
      endpoint: "patient",
      titulos: [
        { texto: "Nombre Paciente", name: "firstName" },
        { texto: "Nombre Tutor", name: "tutor" },
        { texto: "Examenes", name: "examenes" },
        { name: "status" }],
      columnas: [
        { prop: "firstName", type: "link", url: "edit/$id$" },
        { prop: "tutor", type: "text", format: (x) => { return x.firstName + " " + x.lastName } },
        { prop: "documentNumber", type: "link", url: "../ordenes/filtrar/$id$?name=$firstName$+$lastName$", placeholder: "Ver Examenes" },
        { type: "status", url: "patient" },
      ],
    }
  } else {
    tabla1 = {
      endpoint: "patient",
      titulos: [
        { texto: "Nombre Paciente", name: "firstName" },
        { texto: "Nombre Tutor", name: "tutor" },
        { texto: "Examenes", name: "examenes" },
        { name: "status" }],
      columnas: [
        { prop: "firstName", type: "link", url: "edit/$id$" },
        { prop: "tutor", type: "text", format: (x) => { return x.firstName + " " + x.lastName } },
        { prop: "documentNumber", type: "link", url: "../ordenes/filtrar/$id$?name=$firstName$+$lastName$", placeholder: "Ver Examenes" },
        { type: "status", url: "patient" },
      ],
    }

  }

  //Funciones Basicas-----------------------------------------------------------------------
  let { urlCall } = useParams();
  let [modalsVisibility, setModalsVisibility] = useState(modals.map((modal) => { if (modal.urlCall != urlCall) { return "hiddenModal" } else { return "visibleModal" } }));
  const navigate = useNavigate();
  let location = useLocation();

  const openModal = (modalNumber) => {
    navigate(modals[modalNumber].urlCall);
  }

  let [forceRender, setForceRender] = useState(0);
  const sendToRender = () => {
    setForceRender(forceRender + 1);
  };

  useEffect(() => {
    setModalsVisibility(modals.map((modal) => { if (modal.urlCall != urlCall) { return "hiddenModal" } else { return "visibleModal" } }));
    traerTutores();
    tipoAnimal();
  }, [location]);

  async function traerTutores() {
    var resp = await api.get("tutor?paginate=2000", infoUsuario.token);
    let docs = {};
    if (!resp.error) {
      const tutore = resp.info.map((c) => {
        const id = String(c.id);
        docs[id] = c.documentNumber;
        return { text: c.firstName + " " + c.lastName, value: c.id, };
      });
      setTuto(tutore);
    }
  }

  async function tipoAnimal() {
    var resp = await api.get("species?paginate=2000", infoUsuario.token);

    if (!resp.error) {
      let especies = resp.info.map((c) => {
        return { value: c.id, text: c.name }
      });
      setEspe(especies);
    }
  }

  return (
    <>
      {modals.map((modal, index) => {
        return <Modal key={index} modalNumber={index} visibility={modalsVisibility} info={modal} sendToRender={sendToRender} />
      })}


      <div className="pageHeading">
        <h1><FontAwesomeIcon icon={icono} /> {titulo}</h1>
        {
          infoUsuario.role.name !== "DOCTOR" && infoUsuario.role.name !== "CLINIC" ?
            (
              <Link to="new">+</Link>
            )
            :
            (
              <></>
            )
        }
      </div>



      <Tabla info={tabla1} forceRender={forceRender} />

    </>
  );

};

export default Modulo;